import * as angular from "angular";
import {IController} from "angular";
import {PlanningViewSettingsResourcesModel} from "../../../models/planning-view-settings.model";

export class PlanningDraftResourcesSettingsPanelTemplateComponent implements IController {

  settings: PlanningViewSettingsResourcesModel;
  panelRef: any;

  public settingsCopy: PlanningViewSettingsResourcesModel;
  public enabledSections: {
    columns: boolean,
    load: boolean,
    capacity: boolean
  };

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
    this.enabledSections = {
      columns: true,
      load: true,
      capacity: true
    }
  }

  onChangeColumns(columnKey, isEnabled) {
    this.settingsCopy.columns[columnKey] = isEnabled;
  }

  onChangeLoad(loadKey, isEnabled) {
    this.settingsCopy.load[loadKey] = isEnabled;
  }

  onChangeCapacity(loadKey, isEnabled) {
    this.settingsCopy.capacity[loadKey] = isEnabled;
  }

  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
  .module('bringoz.admin.agents')
  .component('planningDraftResourcesSettingsPanelTemplate', {
    bindings: {
      settings: '<',
      panelRef: '<'
    },
    template: require('./planning-draft-resources-settings-panel-template.html').default,
    controller: PlanningDraftResourcesSettingsPanelTemplateComponent
  });
